import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/jbl.jpg";
import "../style/styles.css";
import "../style/Jewsof.css";

const JewSof = () => {
  const quickStats = [
    { value: "GST", label: "Enabled Billing" },
    { value: "QR", label: "Barcode / QR Code" },
    { value: "ERP", label: "Jewellery Workflow" },
    { value: "Tally", label: "Accounting Support" },
  ];

  const keyModules = [
    {
      title: "Contractual Worker / Karigar",
      text:
        "Manage gold issue to karigar, unfinished ornament receipt, finished ornament receipt, soldering making, tezabi conversion, worker charges and pending job registers.",
    },
    {
      title: "Sales Management",
      text:
        "Handle customer order, advance against order, order cancellation, order delivery, counter sales, sales return, estimate or quotation, GST collection and barcode generation.",
    },
    {
      title: "Purchase Management",
      text:
        "Manage raw gold purchase, finished product purchase, purchase return, old gold purchase, old gold transfer, pure gold register and GST ITC reports.",
    },
    {
      title: "Stock Reports",
      text:
        "Track raw material stock, finished product stock summary, finished product closing stock, old gold stock, soldering stock and unfinished product stock.",
    },
    {
      title: "Outstanding Reports",
      text:
        "Monitor debtor balance, creditor balance and ageing analysis for debtors and creditors with clear outstanding control.",
    },
    {
      title: "Accounting Reports",
      text:
        "Generate cash bank book, journal book, purchase/sales registers, ledger, trial balance, profit and loss, bank reconciliation and GST reports.",
    },
  ];

  const karigarFeatures = [
    "Gold Issue to Karigar",
    "Unfinished Ornaments Receipt from Karigar",
    "Unfinished Ornaments Issue to Goldsmith",
    "Finished Ornaments Receipt from Goldsmith",
    "Soldering Making",
    "Old Gold converts to Pure Gold (Tezabi)",
    "Worker Transaction Details / Summary",
    "Pending Jobs Register",
    "Worker Charges Details",
  ];

  const salesFeatures = [
    "Customer Order",
    "Advance against Order",
    "Order Cancellation",
    "Order sends to Contractual Workers",
    "Order Delivery for Gold / Silver / Diamond / Platinum",
    "Counter Sales",
    "Sales Return",
    "Estimate or Quotation",
    "Payment Mode Wise Sales Register",
    "Customer Order Register",
    "Pending Customer Order Register",
    "Register of Customer Gold and Advance",
    "GST Collection Register",
    "Barcode / QR Code Generation",
  ];

  const purchaseFeatures = [
    "Raw Gold Purchase",
    "Finished Product Purchase",
    "Finished Product Received from Workers",
    "Purchase Return",
    "Old Gold Purchase",
    "Old Gold Transfer to Finished Product",
    "Pure Gold Purchase Register",
    "Old Gold Purchase Register",
    "GST ITC Reports",
  ];

  const stockFeatures = [
    "Raw Material Stock",
    "Finished Product Stock Summary",
    "Gold / Diamond / Silver / Platinum Closing Stock",
    "Old Gold Stock Register",
    "Soldering Stock Register",
    "Unfinished Product Stock Register",
  ];

  const accountingFeatures = [
    "Cash Bank Book",
    "Journal Book",
    "Purchase Register",
    "Purchase Return Register",
    "Sales Register",
    "Sales Return Register",
    "Ledger",
    "Trial Balance",
    "Trading and Profit & Loss Statement",
    "Bank Reconciliation",
    "Interest Calculation",
    "Confirmation of Accounts",
    "Cost Centre Reports",
    "GST Type Wise Sales Register",
    "GSTR-I, GSTR-II and GSTR-3B Reports",
  ];

  const seoKeywords = [
    "Jewellery Billing Software",
    "Jewellery Management Software",
    "Jewellery ERP Software",
    "Jewellery Shop Software",
    "Jewellery Outlet Software",
    "Jewellery Retail Software",
    "Jewellery POS Software",
    "Gold Jewellery Software",
    "Silver Jewellery Software",
    "Diamond Jewellery Software",
    "Platinum Jewellery Software",
    "GST Jewellery Billing Software",
    "Jewellery Inventory Software",
    "Jewellery Stock Management Software",
    "Jewellery Accounting Software",
    "Jewellery Barcode Software",
    "Jewellery QR Code Software",
    "Karigar Management Software",
    "Goldsmith Management Software",
    "Jewellery Manufacturing Software",
    "Jewellery Order Management Software",
    "Customer Order Management Software",
    "Old Gold Purchase Software",
    "Raw Gold Purchase Software",
    "Gold Stock Software",
    "Diamond Stock Software",
    "Silver Stock Software",
    "Platinum Stock Software",
    "Jewellery Purchase Software",
    "Jewellery Sales Software",
    "Jewellery Estimate Software",
    "Jewellery Quotation Software",
    "GSTR Jewellery Software",
    "Jewellery Software in India",
    "Jewellery Software in Siliguri",
    "Jewellery Software in West Bengal",
  ];

  const relatedSearchGroups = [
    {
      title: "Jewellery Billing, POS & GST",
      text:
        "JewSof supports jewellery outlets with GST billing, counter sales, sales return, estimate, quotation, payment mode wise sales register, GST collection and barcode billing.",
      terms: [
        "Jewellery Billing Software",
        "Jewellery POS Software",
        "Jewellery Shop Billing Software",
        "Jewellery Outlet Software",
        "Jewellery Retail Software",
        "GST Jewellery Billing Software",
        "Gold Jewellery Billing Software",
        "Silver Jewellery Billing Software",
        "Diamond Jewellery Billing Software",
        "Platinum Jewellery Billing Software",
        "Jewellery Estimate Software",
        "Jewellery Quotation Software",
        "Jewellery Sales Software",
        "Jewellery Sales Return Software",
        "GST Collection Register Software",
        "GSTR Jewellery Software",
      ],
    },
    {
      title: "Karigar, Goldsmith & Manufacturing",
      text:
        "JewSof manages gold issue to karigar, unfinished ornament receipt, finished ornament receipt, worker charges, pending jobs and complete jewellery manufacturing workflow.",
      terms: [
        "Karigar Management Software",
        "Goldsmith Management Software",
        "Jewellery Manufacturing Software",
        "Gold Issue to Karigar Software",
        "Unfinished Ornament Software",
        "Finished Ornament Software",
        "Worker Charges Software",
        "Pending Job Register Software",
        "Jewellery Worker Management Software",
        "Soldering Making Software",
        "Tezabi Conversion Software",
        "Old Gold to Pure Gold Software",
      ],
    },
    {
      title: "Order, Purchase & Old Gold",
      text:
        "JewSof handles customer orders, advance against order, order delivery, raw gold purchase, finished product purchase, old gold purchase and purchase return.",
      terms: [
        "Jewellery Order Management Software",
        "Customer Order Management Software",
        "Jewellery Advance Order Software",
        "Pending Customer Order Software",
        "Jewellery Order Delivery Software",
        "Jewellery Purchase Software",
        "Raw Gold Purchase Software",
        "Finished Product Purchase Software",
        "Old Gold Purchase Software",
        "Old Gold Transfer Software",
        "Pure Gold Purchase Register Software",
        "GST ITC Jewellery Software",
      ],
    },
    {
      title: "Stock, Barcode & Inventory",
      text:
        "JewSof provides jewellery stock reports for raw material, finished product, old gold, soldering stock, unfinished product and barcode or QR code generation.",
      terms: [
        "Jewellery Inventory Software",
        "Jewellery Stock Management Software",
        "Jewellery Barcode Software",
        "Jewellery QR Code Software",
        "Gold Stock Software",
        "Silver Stock Software",
        "Diamond Stock Software",
        "Platinum Stock Software",
        "Raw Material Stock Software",
        "Finished Product Stock Software",
        "Old Gold Stock Register Software",
        "Soldering Stock Register Software",
        "Unfinished Product Stock Software",
        "Jewellery Closing Stock Software",
      ],
    },
    {
      title: "Accounting, Outstanding & Reports",
      text:
        "JewSof includes jewellery accounting reports, ledger, trial balance, profit and loss, outstanding, ageing analysis, cost centre and GST return reports.",
      terms: [
        "Jewellery Accounting Software",
        "Jewellery Ledger Software",
        "Jewellery Trial Balance Software",
        "Jewellery Profit and Loss Software",
        "Jewellery Outstanding Software",
        "Debtor Balance Software",
        "Creditor Balance Software",
        "Ageing Analysis Software",
        "Cash Bank Book Software",
        "Jewellery Purchase Register Software",
        "Jewellery Sales Register Software",
        "Bank Reconciliation Software",
        "Cost Centre Report Software",
        "GSTR-1 Jewellery Software",
        "GSTR-3B Jewellery Software",
      ],
    },
    {
      title: "Jewellery Software by Location",
      text:
        "JewSof is suitable for jewellery showrooms and jewellery outlets looking for billing, barcode, stock, karigar, accounting and GST software in Siliguri, West Bengal and India.",
      terms: [
        "Jewellery Software in India",
        "Jewellery Billing Software in India",
        "Jewellery ERP Software in India",
        "Jewellery Software in Siliguri",
        "Jewellery Billing Software in Siliguri",
        "Jewellery Software in West Bengal",
        "Jewellery Shop Software in West Bengal",
        "Jewellery Software Company in Siliguri",
        "Jewellery Software Developer in West Bengal",
        "Gold Jewellery Software in India",
        "Jewellery Outlet Software in India",
      ],
    },
  ];

  const seoPainPoints = [
    {
      title: "Complete jewellery billing control",
      text:
        "JewSof helps jewellery outlets manage GST billing, counter sales, estimates, quotations, sales return, GST collection and payment mode wise sales reports.",
    },
    {
      title: "Karigar and manufacturing workflow",
      text:
        "JewSof controls gold issue to karigar, unfinished ornament receipt, finished ornament receipt, worker charges, soldering making and pending job registers.",
    },
    {
      title: "Accurate jewellery stock tracking",
      text:
        "JewSof tracks raw material stock, finished product stock, gold, silver, diamond, platinum, old gold, soldering stock and unfinished product stock.",
    },
    {
      title: "Accounting and GST reports",
      text:
        "JewSof provides cash bank book, ledger, trial balance, profit and loss, bank reconciliation, cost centre reports and GSTR-I, GSTR-II and GSTR-3B reports.",
    },
  ];

  const faqList = [
    {
      question: "What is JewSof jewellery billing software?",
      answer:
        "JewSof is a GST-enabled jewellery billing, inventory, karigar, stock and accounting software for gold, silver, diamond and platinum jewellery businesses.",
    },
    {
      question: "Does JewSof support karigar and goldsmith management?",
      answer:
        "Yes. JewSof supports gold issue to karigar, unfinished ornaments receipt, finished ornaments receipt, soldering making, worker transaction details, worker charges and pending job registers.",
    },
    {
      question: "Can JewSof manage jewellery orders and sales?",
      answer:
        "Yes. JewSof manages customer order, advance against order, order cancellation, order delivery, counter sales, sales return, estimate, quotation and payment mode wise sales register.",
    },
    {
      question: "Does JewSof support jewellery stock and barcode?",
      answer:
        "Yes. JewSof supports barcode and QR code generation, raw material stock, finished product stock, old gold stock, soldering stock and gold, silver, diamond and platinum closing stock.",
    },
    {
      question: "Does JewSof provide GST and accounting reports?",
      answer:
        "Yes. JewSof provides GST collection register, GST ITC reports, cash bank book, journal book, purchase register, sales register, ledger, trial balance, profit and loss, bank reconciliation and GSTR reports.",
    },
  ];

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath = "/JewSof";
  const pageUrl = `${siteUrl}${pagePath}`;
  const heroImageUrl = String(web5 || "").startsWith("http") ? web5 : `${siteUrl}${web5}`;

  const seoTitle =
    "Jewellery Billing Software | JewSof GST, Barcode, Stock, Karigar & Accounting";

  const seoDescription =
    "JewSof is a GST-enabled jewellery billing software for jewellery outlets with barcode, QR code, karigar, sales, purchase, old gold, stock, accounting and GSTR reports.";

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "JewSof",
    alternateName: "JewSof Jewellery Billing and Inventory Software",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Windows, Web",
    url: pageUrl,
    image: heroImageUrl,
    description: seoDescription,
    brand: {
      "@type": "Brand",
      name: "JewSof",
    },
    publisher: {
      "@type": "Organization",
      name: "EBS Software Solution",
      url: siteUrl,
    },
    offers: {
      "@type": "Offer",
      price: "45000",
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      description: "1 licence / multi-user JewSof jewellery software package.",
    },
    featureList: [
      "GST jewellery billing",
      "Barcode and QR code generation",
      "Karigar and goldsmith management",
      "Customer order and advance management",
      "Counter sales and sales return",
      "Raw gold and old gold purchase",
      "Gold, silver, diamond and platinum stock",
      "Finished and unfinished ornament stock",
      "Jewellery accounting reports",
      "GSTR-I, GSTR-II and GSTR-3B reports",
    ],
    keywords: seoKeywords.join(", "),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: siteUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "JewSof Jewellery Billing Software",
        item: pageUrl,
      },
    ],
  };

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="jewsof-detail-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords.join(", ")} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={heroImageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={heroImageUrl} />

        <script type="application/ld+json">
          {JSON.stringify([softwareSchema, faqSchema, breadcrumbSchema])}
        </script>
      </Helmet>

      <section className="jewsof-hero">
        <img
          className="jewsof-hero-bg"
          src={web5}
          alt="JewSof jewellery billing software for GST barcode stock karigar inventory and accounting"
          onError={handleImageError}
        />
        <div className="jewsof-hero-overlay"></div>

        <Container className="jewsof-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="jewsof-hero-content">
                <div className="jewsof-kicker">Jewellery ERP Software</div>
                <h1>JewSof</h1>
                <h2>
                  GST enabled Jewellery Billing, Inventory & Accounting Software
                </h2>
                <p>
                  JewSof is a trusted jewellery billing software and jewellery
                  ERP solution for gold, silver, diamond and platinum jewellery
                  outlets. It covers karigar workflow, customer orders, counter
                  sales, purchase, stock, barcode, QR code, accounting, GST and
                  GSTR reports from one integrated platform.
                </p>

                <div className="jewsof-hero-actions">
                  <a href="#jewsof-modules" className="jewsof-btn jewsof-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="jewsof-btn jewsof-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="jewsof-price-card">
                <span>1 Licence / Multi-User</span>
                <strong>₹45,000/- + GST</strong>
                <p>
                  Designed for jewellery outlets managing gold, silver, diamond,
                  platinum, orders, workers, stock, barcode, GST and accounts.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="jewsof-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="jewsof-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="jewsof-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="jewsof-section-label">Overview</div>
              <h2 className="jewsof-section-title">
                Complete jewellery management system for modern outlets
              </h2>
              <p className="jewsof-text">
                JewSof helps jewellery businesses manage customer orders, stock,
                workers, purchases, sales, returns, accounting and GST reports
                from one integrated system. Its advanced report utility supports
                better business analysis, improved sales control and stronger
                profitability decisions.
              </p>
              <p className="jewsof-text">
                When jewellery business data is crucial, JewSof gives practical
                workflow control for gold, silver, diamond, platinum and other
                jewellery transactions without compromising accuracy.
              </p>
            </Col>

            <Col lg={6}>
              <div className="jewsof-overview-card">
                <h3>JewSof covers</h3>
                <div className="jewsof-overview-grid">
                  <div><span>✓</span><p>Karigar Workflow</p></div>
                  <div><span>✓</span><p>Sales & Order</p></div>
                  <div><span>✓</span><p>Purchase</p></div>
                  <div><span>✓</span><p>Stock Reports</p></div>
                  <div><span>✓</span><p>Outstanding</p></div>
                  <div><span>✓</span><p>Accounting & GST</p></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="jewsof-seo-section">
        <Container>
          <div className="jewsof-heading-center">
            <div className="jewsof-section-label">Why Jewellery Outlets Choose JewSof</div>
            <h2 className="jewsof-section-title">
              Jewellery billing software built for GST, barcode, stock, karigar and accounting
            </h2>
            <p>
              JewSof is designed for jewellery showrooms and jewellery outlets
              that need better control over GST billing, barcode, QR code,
              customer orders, karigar workflow, stock, purchase, old gold,
              accounting and GSTR reports.
            </p>
          </div>

          <Row className="g-4">
            {seoPainPoints.map((item) => (
              <Col lg={3} md={6} key={item.title}>
                <div className="jewsof-seo-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="jewsof-modules-section" id="jewsof-modules">
        <Container>
          <div className="jewsof-heading-center">
            <div className="jewsof-section-label">Key Modules</div>
            <h2 className="jewsof-section-title">
              Jewellery workflow from order to final accounting
            </h2>
            <p>
              JewSof connects manufacturing, stock, sales, purchase and accounts
              for complete jewellery business control.
            </p>
          </div>

          <Row className="g-4">
            {keyModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="jewsof-module-card">
                  <div className="jewsof-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="jewsof-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="jewsof-list-card">
                <div className="jewsof-section-label">Karigar</div>
                <h2>Contractual Worker Management</h2>
                <ul>
                  {karigarFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="jewsof-list-card jewsof-list-card-dark">
                <div className="jewsof-section-label">Sales</div>
                <h2>Sales, Orders & Billing</h2>
                <ul>
                  {salesFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="jewsof-feature-list-section jewsof-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="jewsof-list-card">
                <div className="jewsof-section-label">Purchase</div>
                <h2>Purchase & Old Gold</h2>
                <ul>
                  {purchaseFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="jewsof-list-card">
                <div className="jewsof-section-label">Stock</div>
                <h2>Stock Management</h2>
                <ul>
                  {stockFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="jewsof-accounting-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="jewsof-accounting-title">
                <div className="jewsof-section-label">Accounting</div>
                <h2 className="jewsof-section-title">
                  Complete accounting and GST reporting
                </h2>
                <p>
                  JewSof includes practical accounting reports for cash, bank,
                  purchase, sales, ledger, trial balance, profit and loss, bank
                  reconciliation, cost centres and GST returns.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="jewsof-accounting-grid">
                {accountingFeatures.map((item) => (
                  <div key={item}>
                    <span>✓</span>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="jewsof-faq-section">
        <Container>
          <div className="jewsof-heading-center">
            <div className="jewsof-section-label">FAQ</div>
            <h2 className="jewsof-section-title">
              Questions about JewSof jewellery billing software
            </h2>
            <p>
              Important information for jewellery outlets looking for GST
              billing, barcode, stock, karigar, purchase, sales and accounting
              software.
            </p>
          </div>

          <div className="jewsof-faq-list">
            {faqList.map((item) => (
              <div className="jewsof-faq-item" key={item.question}>
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="jewsof-cta-section">
        <Container>
          <div className="jewsof-cta-card">
            <div>
              <span>Ready to manage your jewellery business professionally?</span>
              <h2>Use JewSof for billing, stock, karigar and accounting.</h2>
              <p>
                Get a GST-enabled jewellery ERP with order, sales, purchase,
                stock, barcode, QR code, old gold, accounting and GSTR reporting
                modules.
              </p>
            </div>
            <Link to="/EmailContactForm" className="jewsof-btn jewsof-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>

      <section className="jewsof-corporate-keywords-section">
        <Container>
          <div className="jewsof-corporate-keywords-head">
            <div className="jewsof-section-label">Related Solutions</div>
            <h2>Jewellery billing, barcode, stock, karigar and accounting search terms</h2>
            <p>
              JewSof covers important jewellery software requirements with
              professional billing, GST, barcode, QR code, stock, karigar,
              order, purchase, old gold, accounting and GSTR modules.
            </p>
          </div>

          <Row className="g-4">
            {relatedSearchGroups.map((group) => (
              <Col lg={6} key={group.title}>
                <div className="jewsof-corporate-keyword-card">
                  <h3>{group.title}</h3>
                  <p>{group.text}</p>

                  <div className="jewsof-corporate-keyword-list">
                    {group.terms.map((term) => (
                      <span key={term}>{term}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default JewSof;